module.exports = "/images/close.png?17912602f2a08345f0da7d380077086e";